// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Inside the page Suspense boundary, AFTER the page's own passive effects. */
export function TourRouteCommitMarker() {
  const { pathname, key } = useLocation();
  const [committedKey, setCommittedKey] = useState<string | null>(null);
  useEffect(() => {
    setCommittedKey(key);
  }, [key]);
  // An old retained page, a fallback or the destination's first render must not
  // certify that navigation has committed. This marker says nothing about API
  // readiness: the tour separately checks the page's loading/error states.
  return committedKey === key ? (
    <span hidden data-tour-route={pathname} data-tour-route-key={key} />
  ) : null;
}
